import React from 'react';

import { Env } from '@contexts/AppContext';
import { finance_path, technology_path } from '@routes';
import { User } from '@utils/backend-api/currentUser';

import { Article } from '../../../interfaces/homepage';
import TopArticlesSection, { Page } from '../../FeedItems/TopArticlesSection';
import MainFeed from '../../MainFeed';
import Tabs from '../../Tabs';
import Header from './Header';
import PageContainer from './PageContainer';

interface HighlightProps {
  env: Env;
  feedArticles: Article[];
  header: string;
  highlightType: string;
  initialCurrentUser?: User;
  isWebview: boolean;
  sideArticles: Article[];
  subheader: string;
  topArticle: Article;
  view: string;
}

const POPULAR = 'popular';
const RECENT = 'recent';
enum HighlightTypeToPath {
  technology = technology_path,
  finance = finance_path,
}

const Highlight = ({
  env,
  feedArticles,
  header,
  highlightType,
  initialCurrentUser,
  isWebview,
  sideArticles,
  subheader,
  topArticle,
  view,
}: HighlightProps): JSX.Element => {
  return (
    <PageContainer initialCurrentUser={initialCurrentUser} env={env} isWebview={isWebview}>
      <Header header={header} subheader={subheader} />
      <Tabs
        customPath={HighlightTypeToPath[highlightType]}
        tabs={[
          {
            to: RECENT,
            text: 'Latest',
          },
          {
            to: POPULAR,
            text: 'Most popular',
          },
        ]}
        view={view}
      />
      <TopArticlesSection
        page={Page.Highlight}
        sideArticles={sideArticles}
        topArticle={topArticle}
      />
      <div className="px-0 lg:px-0">
        {feedArticles?.length > 0 && (
          <MainFeed feedContent={feedArticles} includeTabs={false} pageSize={6} view={view} />
        )}
      </div>
    </PageContainer>
  );
};

export default Highlight;
